function _(n,i,t){var u=n(113),s=function(n){function i(i){return n.call(this,i)||this}return u.__extends(i,n),i}(n(243).Axis);t.ContinuousAxis=s,s.__name__="ContinuousAxis"}
//# sourceMappingURL=continuous_axis.min.js.map